import { Spin } from 'antd'
import React from 'react'
import { StyledDHSCheckEligibilityLoadingContainer } from './DHSCheckEligibility.styled'

export const DHSCheckEligibilityLoading: React.FC = React.memo(() => {
  return (
    <StyledDHSCheckEligibilityLoadingContainer>
      <Spin size="large" tip="Loading DHS Check Eligibility...">
        <div style={{ padding: 50 }} />
      </Spin>
    </StyledDHSCheckEligibilityLoadingContainer>
  )
})
